import { StoreSchema } from '../../../shared/config/storeConfig/StoreSchema'

export const selectComments = (store: StoreSchema) => store.comment.comments
